import { model } from "../core/model";
import { Config } from "../core/config"

const nav = () => {
    return  /*html*/`
    
                    <div class="login">
                        ${(model.Usuario.isLogged() && model.Usuario.UsuarioUsuario) ?
                                /*html*/`<div class="suscriptor">
                                            <a class="user" title="${model.Usuario.Email}" href="${Config.dominioMiCuenta}">${model.Usuario.Email}</a>
                                                ${(model.Usuario.hasDigitalSuscription()) ?
                                                        /*html*/`<span class="label chapita-conSuscrip">Suscripci&oacute;n digital</span>`
                                                :                                      
                                                        /*html*/`<span class="label chapita-sinSuscrip">Sin suscripci&oacute;n digital</span>`}
                                        </div>
                                        <a href="#" class="button-login next-button nav-login__cambiar" title="Cambiar cuenta" data-step="logout">Cambiar cuenta</a>`
                                :
                                /*html*/`
                                <button type="button" 
                                        class="button-login next-button" 
                                        title="Ir a Iniciar Sesión" 
                                        data-step="ya_tenes_suscripcion"
                                >
                                    Iniciar sesi&oacute;n
                                </button>
                                        `}
                    </div>`
}

const nav2 = () => {
    return  /*html*/`
    
                    <div class="">
                        ${(model.Usuario.isLogged() && model.Usuario.UsuarioUsuario) ?
                                /*html*/``
                                :
                                /*html*/`
                                <button type="button" 
                                        class="wall-encabezado__button next-button"
                                        data-step="ya_tenes_suscripcion"
                                >
                                    Si ya sos suscriptor, iniciá sesión
                                </button>
                                        `}
                    </div>`
}

module.exports = { 
    nav :nav,
    nav2 : nav2
}




// WEBPACK FOOTER //
// ./Statics/scripts/paywall/views/nav.js